module.exports = __webpack_public_path__ + "img/alert-time.0622af92.svg";